import {
  FEATURED_AI_MODEL_LABELS,
  type AiModelId,
} from "@/ai/model/model-catalog";
import type { OpenRouterModel } from "@/ai/model/openrouter-models";

export const EFFORT_LABELS: Record<string, string> = {
  none: "Desligado",
  minimal: "Mínimo",
  low: "Baixo",
  medium: "Médio",
  high: "Alto",
  xhigh: "Muito alto",
  max: "Máximo",
};

export const reasoningOptions = (model: OpenRouterModel) => {
  const reasoning = model.reasoning;
  if (!reasoning) return [];
  const defaultLabel = reasoning.mandatory
    ? (EFFORT_LABELS[reasoning.defaultEffort ?? ""] ?? "padrão")
    : reasoning.defaultEnabled === true && reasoning.defaultEffort
      ? (EFFORT_LABELS[reasoning.defaultEffort] ?? "padrão")
      : "desligado";
  const options: Array<{ value: string | null; label: string }> = [
    { value: null, label: `Auto (${defaultLabel})` },
  ];
  if (!reasoning.mandatory) options.push({ value: "none", label: "Desligado" });
  if (reasoning.supportedEfforts.length) {
    options.push(
      ...reasoning.supportedEfforts
        .filter((effort) => effort !== "none")
        .map((effort) => ({
          value: effort,
          label: EFFORT_LABELS[effort] ?? effort,
        })),
    );
  } else {
    options.push({ value: "on", label: "Ligado" });
  }
  return options;
};

export const CACHE_HIT_RATE = 0.5; // 50% de cache hit na entrada
export const OUTPUT_TO_INPUT_RATIO = 0.15; // saída = 15% do volume de entrada

export const averageCost = (model: OpenRouterModel) => {
  if (!model.pricing) return null;
  const { prompt, completion, inputCacheRead } = model.pricing;
  return (
    prompt * (1 - CACHE_HIT_RATE) +
    inputCacheRead * CACHE_HIT_RATE +
    completion * OUTPUT_TO_INPUT_RATIO
  );
};

export const costBenefit = (model: OpenRouterModel) => {
  if (!model.intelligence) return null;
  const avg = averageCost(model);
  if (avg === null) return null;
  if (avg <= 0) return Infinity;
  return model.intelligence.intelligenceIndex / avg;
};

export const modelLabel = (
  id: AiModelId | null | undefined,
  models: OpenRouterModel[],
) =>
  (id && FEATURED_AI_MODEL_LABELS[id]) ||
  models.find((model) => model.id === id)?.name ||
  id ||
  "Modelo de IA";

export const formatPriceUsd = (value: number) =>
  `$${value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
